import React from 'react';

import classes from './PopularSearch.module.scss';

const PopularSearch = () => {
    return (
        <div className={`container ${classes['wrapper']}`}>
            <div className="row d-flex align-items-center justify-content-center">
                <div className="col-xl-10 col-12">
                    <h2>Popular Searches</h2>
                    <div className={classes['popular-search-list']}>
                        <a href="/explore?search_keyword=gmp">GMP</a>
                        <a href="/explore?search_keyword=Pharmacovigilance">Pharmacovigilance</a>
                        <a href="/explore?search_keyword=Quality+Management">Quality Management</a>
                        <a href="/explore?search_keyword=Career+Development">Career Development</a>
                        <a href="/explore?search_keyword=Validation">Validation</a>
                        <a href="/explore?search_keyword=Regulatory">Regulatory</a>
                        <a href="/explore?search_keyword=Batch+Management">Batch Management</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopularSearch;